(() => {
  const roots = document.querySelectorAll('[data-scan-shop]');
  roots.forEach(init);

  function init(root) {
    const $ = (s) => root.querySelector(s);

    const video = $('[data-scan-video]');
    const startBtn = $('[data-scan-start]');
    const stopBtn = $('[data-scan-stop]');
    const status = $('[data-scan-status]');

    const eventName =
      new URLSearchParams(location.search).get('event') || '';

    const duplicateWindow =
      Number(root.dataset.duplicateWindow || 5000);

    let quantity = 1;
    let controls = null;
    let catalog = null;
    let busy = false;

    const recentCodes = new Map();

    const money = (cents, currency) => {
      try {
        return new Intl.NumberFormat('ro-RO', {
          style: 'currency',
          currency: currency || 'RON'
        }).format(cents / 100);
      } catch (_) {
        return `${(cents / 100).toFixed(2)} lei`;
      }
    };

    function message(type, title, detail) {
      status.className =
        `scan-shop__status${type ? ` is-${type}` : ''}`;

      $('[data-status-icon]').textContent =
        type === 'success'
          ? '✓'
          : type === 'error'
            ? '!'
            : '•';

      $('[data-status-title]').textContent = title;
      $('[data-status-detail]').textContent = detail || '';
    }

    /*
     * CATALOG DINAMIC
     *
     * Catalogul este citit direct din feed-ul Shopify:
     * /pages/contact?view=scan-index
     *
     * Feed-ul este paginat. Citim automat toate paginile.
     * Nu mai folosim catalog static și nu salvăm catalogul
     * în sessionStorage.
     */
    async function getCatalog() {
      if (catalog) return catalog;

      if (!root.dataset.catalogFeedUrl) {
        throw new Error(
          'Feed-ul catalogului nu este configurat.'
        );
      }

      catalog = {};

      try {
        const timestamp = Date.now();

        const firstResponse = await fetch(
          `${root.dataset.catalogFeedUrl}&page=1&_=${timestamp}`,
          {
            credentials: 'same-origin',
            cache: 'no-store'
          }
        );

        if (!firstResponse.ok) {
          throw new Error(
            'Prima pagină a catalogului nu a putut fi încărcată.'
          );
        }

        const firstData = await firstResponse.json();

        const totalPages =
          Math.max(1, Number(firstData.pages || 1));

        const pages = [firstData];

        /*
         * Încărcăm restul paginilor în paralel.
         * Este mai rapid decât să așteptăm fiecare pagină pe rând.
         */
        if (totalPages > 1) {
          const requests = [];

          for (let page = 2; page <= totalPages; page++) {
            requests.push(
              fetch(
                `${root.dataset.catalogFeedUrl}&page=${page}&_=${timestamp}`,
                {
                  credentials: 'same-origin',
                  cache: 'no-store'
                }
              ).then(async (response) => {
                if (!response.ok) {
                  throw new Error(
                    `Pagina ${page} a catalogului nu a putut fi încărcată.`
                  );
                }

                return response.json();
              })
            );
          }

          const remainingPages =
            await Promise.all(requests);

          pages.push(...remainingPages);
        }

        /*
         * Construim indexul:
         *
         * barcode -> produs
         * SKU     -> produs
         */
        pages
          .flatMap((page) => page.items || [])
          .forEach((item) => {
            [item.barcode, item.sku]
              .filter(Boolean)
              .forEach((key) => {
                const normalizedKey =
                  String(key).trim().toLowerCase();

                if (normalizedKey) {
                  catalog[normalizedKey] = item;
                }
              });
          });

      } catch (error) {
        console.error(
          'Scan & Shop catalog error:',
          error
        );

        catalog = null;

        throw new Error(
          'Catalogul produselor nu a putut fi încărcat. Reîncarcă pagina și încearcă din nou.'
        );
      }

      if (!Object.keys(catalog).length) {
        catalog = null;

        throw new Error(
          'Catalogul scannerului este gol.'
        );
      }

      return catalog;
    }

    function parseVariantId(value) {
      const v = String(value).trim();

      const match = v.match(
        /^(?:111:variant:|variant:)(\d{8,})$/i
      );

      return match ? Number(match[1]) : null;
    }

    async function resolveCode(raw) {
      const code = String(raw).trim();

      const directId = parseVariantId(code);

      if (directId) {
        return {
          id: directId,
          code,
          title: `Produs #${directId}`
        };
      }

      const normalized = code
        .replace(
          /^111:(?:sku|barcode):/i,
          ''
        )
        .trim()
        .toLowerCase();

      const data = await getCatalog();

      const item = data[normalized];

      if (!item) {
        throw new Error(
          'Codul nu a fost găsit în catalog.'
        );
      }

      return {
        ...item,
        code
      };
    }

    async function addScanned(raw) {
      if (busy) return;

      const code = String(raw).trim();
      const now = Date.now();

      if (
        recentCodes.has(code) &&
        now - recentCodes.get(code) < duplicateWindow
      ) {
        message(
          '',
          'Cod deja citit',
          'Ține camera departe câteva secunde sau schimbă cantitatea.'
        );

        return;
      }

      busy = true;

      message(
        '',
        'Se adaugă…',
        code
      );

      try {
        const product =
          await resolveCode(code);

        const properties = eventName
          ? {
              '_event': eventName,
              '_scan_source': 'scan-shop'
            }
          : {
              '_scan_source': 'scan-shop'
            };

        const formData =
          new FormData();

        formData.append(
          'id',
          String(product.id)
        );

        formData.append(
          'quantity',
          String(quantity)
        );

        Object.entries(properties)
          .forEach(([key, value]) => {
            formData.append(
              `properties[${key}]`,
              value
            );
          });

        const response = await fetch(
          root.dataset.cartAddUrl,
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json'
            },
            body: formData
          }
        );

        const result =
          await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            'Produsul nu a putut fi adăugat.'
          );
        }

        recentCodes.set(
          code,
          now
        );

        const line =
          result.items
            ? result.items[0]
            : result;

        message(
          'success',
          'Adăugat în coș',
          `${line?.product_title || product.title || 'Produs'} × ${quantity}`
        );

        addRecent(
          line || product,
          quantity
        );

        root.classList.remove(
          'scan-shop__flash'
        );

        void root.offsetWidth;

        root.classList.add(
          'scan-shop__flash'
        );

        window.dataLayer =
          window.dataLayer || [];

        window.dataLayer.push({
          event: 'scan_shop_add',
          scan_event:
            eventName || undefined,
          scan_code: code,
          variant_id: product.id,
          quantity
        });

        document.dispatchEvent(
          new CustomEvent(
            'cart:refresh'
          )
        );

        await refreshCart();

      } catch (error) {
        message(
          'error',
          'Nu am putut adăuga produsul',
          error.message
        );

        if (navigator.vibrate) {
          navigator.vibrate(
            [80, 50, 80]
          );
        }

      } finally {
        busy = false;
      }
    }

    function addRecent(item, qty) {
      const li =
        document.createElement('li');

      const image =
        item.featured_image ||
        item.image;

      li.innerHTML =
        `${
          image
            ? `<img src="${escapeHtml(image)}&width=96" alt="">`
            : '<span></span>'
        }` +
        `<div>` +
        `<strong>${escapeHtml(item.product_title || item.title || 'Produs')}</strong>` +
        `<small>Adăugat acum</small>` +
        `</div>` +
        `<b>× ${qty}</b>`;

      $('[data-recent-list]')
        .prepend(li);

      while (
        $('[data-recent-list]')
          .children.length > 4
      ) {
        $('[data-recent-list]')
          .lastElementChild
          .remove();
      }
    }

    const escapeHtml = (value) =>
      String(value || '')
        .replace(
          /[&<>'"]/g,
          (c) => ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            "'": '&#39;',
            '"': '&quot;'
          }[c])
        );

    async function refreshCart() {
      const response =
        await fetch(
          root.dataset.cartJsonUrl,
          {
            credentials: 'same-origin'
          }
        );

      const cart =
        await response.json();

      $('[data-cart-count]')
        .textContent =
        cart.item_count;

      $('[data-cart-total]')
        .textContent =
        money(
          cart.total_price,
          cart.currency
        );

      if (
        eventName &&
        cart.attributes?.scan_event !== eventName
      ) {
        fetch(
          '/cart/update.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type':
                'application/json'
            },
            body: JSON.stringify({
              attributes: {
                scan_event: eventName
              }
            })
          }
        );
      }
    }

    async function startScanner() {
      startBtn.disabled = true;

      message(
        '',
        'Pornim camera…',
        'Acceptă permisiunea când telefonul o solicită.'
      );

      try {
        if (!window.isSecureContext) {
          throw new Error(
            'Camera necesită o pagină HTTPS.'
          );
        }

        if (!window.ZXingBrowser) {
          throw new Error(
            'Scannerul nu s-a încărcat. Reîncarcă pagina.'
          );
        }

        const reader =
          new ZXingBrowser
            .BrowserMultiFormatReader();

        controls =
          await reader.decodeFromConstraints(
            {
              audio: false,
              video: {
                facingMode: {
                  ideal: 'environment'
                }
              }
            },
            video,
            (result) => {
              if (result) {
                addScanned(
                  result.getText()
                );
              }
            }
          );

        root.dataset.scannerState =
          'running';

        startBtn.hidden = true;
        stopBtn.hidden = false;

        message(
          '',
          'Scanează produsul',
          'Încadrează barcode-ul sau codul QR în chenar.'
        );

      } catch (error) {
        message(
          'error',
          'Camera nu a pornit',
          error.name === 'NotAllowedError'
            ? 'Permite accesul la cameră din setările browserului.'
            : error.message
        );

        startBtn.disabled = false;
      }
    }

    function stopScanner() {
      if (controls) {
        controls.stop();
      }

      controls = null;

      if (video.srcObject) {
        video.srcObject
          .getTracks()
          .forEach(
            (track) =>
              track.stop()
          );
      }

      root.dataset.scannerState =
        'idle';

      startBtn.hidden = false;
      startBtn.disabled = false;
      stopBtn.hidden = true;

      message(
        '',
        'Camera este oprită',
        'O poți porni din nou oricând.'
      );
    }

    startBtn.addEventListener(
      'click',
      startScanner
    );

    stopBtn.addEventListener(
      'click',
      stopScanner
    );

    $('[data-qty-minus]')
      .addEventListener(
        'click',
        () => {
          quantity =
            Math.max(
              1,
              quantity - 1
            );

          $('[data-qty]')
            .textContent =
            quantity;
        }
      );

    $('[data-qty-plus]')
      .addEventListener(
        'click',
        () => {
          quantity =
            Math.min(
              99,
              quantity + 1
            );

          $('[data-qty]')
            .textContent =
            quantity;
        }
      );

    const toggle =
      $('[data-manual-toggle]');

    if (toggle) {
      toggle.addEventListener(
        'click',
        () => {
          const form =
            $('[data-manual-form]');

          form.hidden =
            !form.hidden;

          if (!form.hidden) {
            $('[data-manual-input]')
              .focus();
          }
        }
      );
    }

    const form =
      $('[data-manual-form]');

    if (form) {
      form.addEventListener(
        'submit',
        (e) => {
          e.preventDefault();

          const input =
            $('[data-manual-input]');

          if (input.value.trim()) {
            addScanned(
              input.value
            );
          }

          input.select();
        }
      );
    }

    document.addEventListener(
      'visibilitychange',
      () => {
        if (
          document.hidden &&
          controls
        ) {
          stopScanner();
        }
      }
    );

    refreshCart()
      .catch(() => {
        message(
          'error',
          'Coșul nu a putut fi citit',
          'Reîncarcă pagina și încearcă din nou.'
        );
      });
  }
})();